import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import LastComment from '../../../../components/commentsChat/LastComment/LastComment';
import CommentsModal from '../../../../components/commentsChat/CommentsModal/CommentsModal';
import { setEntityIdAction } from '../../../../actions/commentsActions/commentsActions';
import {
  getDocumentCommentsAction,
  sendDocumentCommentAction,
} from '../../../../actions/commentsActions/documentsCommentsActions/documentsCommentsActions';
import getLastComment from '../../requests/getLastComment';
import CommentsChatFooter from '../../../../components/commentsChat/commentsFooter/CommentsChatFooter/CommentsChatFooter';

const Comments = () => {
  const [chatOpened, setChatOpened] = useState(false);

  const dispatch = useDispatch();

  const { documentId, formValues } = useSelector(documentDrawerSelector);

  const sendComment = useCallback(
    (entityId, message, attachedFiles, isEdit) => {
      dispatch(
        sendDocumentCommentAction(entityId, message, attachedFiles, isEdit)
      );
    },
    []
  );

  const closeCommentsModal = () => {
    setChatOpened(false);
  };

  const openCommentsModal = () => {
    setChatOpened(true);
  };

  const footerNode = (
    <CommentsChatFooter
      entityId={documentId}
      sendComment={sendComment}
      showCheckboxOptions={false}
    />
  );

  const lightboxConfig = useMemo(
    () => ({
      url: `/docs/attachment`,
      props: { docId: documentId, fileName: '' },
    }),
    [documentId]
  );

  return (
    <div style={{ border: '1px solid #0995ED', borderRadius: 8 }}>
      <LastComment
        onClick={openCommentsModal}
        setEntityIdAction={setEntityIdAction}
        getEntityCommentsAction={getDocumentCommentsAction}
        entityId={documentId}
        getLastComment={getLastComment}
        withBorder={false}
        withTitle
      />
      <CommentsModal
        lightboxConfig={lightboxConfig}
        visible={chatOpened}
        onClose={closeCommentsModal}
        title={`Комментарии • ${formValues?.docNumber}`}
        footer={footerNode}
        zIndex={9999999}
      />
    </div>
  );
};

export default Comments;
